import { createEvent, type ScheduleEventPayload } from "./history-events";
import { useHistoryStore } from "../../stores/history-store";

export function dispatchScheduleEvent(payload: ScheduleEventPayload, mergeKey?: string) {
  const event = createEvent(payload, mergeKey);
  useHistoryStore.getState().append(event);
}

export function endHistoryMerge() {
  useHistoryStore.getState().sealMerge();
}
